import { createSlice } from '@reduxjs/toolkit';
import { findCar } from './api';
import { initialState } from './api/interface';

const carsSlice = createSlice({
  name: 'cars',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload.loading;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findCar.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findCar.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findCar.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });

  },
});

export const { setLimit, setSkip, setCurrentPage, reset, setStatus, setLoading } =
  carsSlice.actions;
export default carsSlice.reducer;
